import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService } from 'src/app/core/auth/account.service';
import { AuthServerProvider } from 'src/app/core/auth/auth-jwt.service';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';

@Component({
    selector: 'app-redirect-component',
    templateUrl: './redirect-component.component.html',
    styleUrls: ['./redirect-component.component.scss'],
    standalone: false
})
export class RedirectComponentComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authServerProvider: AuthServerProvider,
    private stateStorageService: StateStorageService,
    private accountService: AccountService,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      const routeAddress = params.get('routeTo');
      const secretToken = params.get('secretToken');
      const workflowId = params.get('workflowId');
      const workOrderId = params.get('workOrderId');
      const financialYear = params.get('financialYear');
      const redirection = params.get('redirection');

      let redirectUrl = '';
      let redirect;
      let loginBySecret = false;

      if (redirection === 'email') {
        redirect = {
          routerLink: '/erp/ecomProcess/workorder',
          queryParams: {
            workflowId: workflowId,
            workOrderId: workOrderId,
            financialYear: financialYear,
            redirection: 'email',
          },
        };
      } else {
        redirect = {
          routerLink: '/erp/ecomProcess/workorder',
          queryParams: {
            workflowId: workflowId,
            workOrderId: workOrderId,
            financialYear: financialYear,
            redirection: 'mobile',
            tabtoshow: routeAddress,
          },
        };
        loginBySecret = true;
      }

      this.stateStorageService.storeUrl(JSON.stringify(redirect));

      let accessToken =
        this.localStorageService.retrieve('authenticationToken') ??
        this.sessionStorageService.retrieve('authenticationToken');

      if (loginBySecret && secretToken) {
        this.loginBySecretToken(secretToken);
      } else if (accessToken) {
        this.router.navigate([redirect.routerLink], {
          queryParams: redirect.queryParams,
        });
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  async loginBySecretToken(secrettoken: string) {
    let loginSuccess = await this.loginBySecretTokenPromise(secrettoken);
    this.accountService.identity().subscribe(
      () => {
        let redirect = JSON.parse(this.stateStorageService.getUrl() || '');
        this.router.navigate([redirect.routerLink], {
          queryParams: redirect.queryParams,
        });
      },
      () => {}
    );
  }

  private loginBySecretTokenPromise(secrettoken: string): Promise<string> {
    return new Promise<string>((resolve) => {
      this.authServerProvider.secretTokenAuthentication(secrettoken).subscribe(
        () => {
          //this.sharedService.getMasterService(); // TBD need to refine code

          resolve('SUCCESS');
        },
        () => {
          resolve('FAILED');
        }
      );
    });
  }
}
